import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeachShoes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_1194)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.9062 13.2237H16.3685L11.7623 10.1067C11.6594 10.0375 11.5346 10.0001 11.4062 10H8.17657C7.00792 9.99726 6.00978 10.7602 5.82076 11.8007L5.5579 13.2237H3.09375C2.76586 13.2237 2.5 13.4636 2.5 13.7594C2.5 14.0553 2.76586 14.2951 3.09375 14.2951H20.9062C21.2342 14.2951 21.5 14.0553 21.5 13.7594C21.5 13.4636 21.2342 13.2237 20.9062 13.2237ZM14.3887 13.2237H11.6117L8.27206 11.0714H11.2085L14.3887 13.2237ZM6.99197 11.9765C7.01357 11.8577 7.06169 11.7488 7.12152 11.6473L9.56764 13.2237H6.76159L6.99197 11.9765Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_1194",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 5,
			fill: "white",
			transform: "translate(2.5 10)"
		})
	}) })]
});
export default SvgBeachShoes;
